import { privacy } from './privacy';
import { cookies } from './cookies';
import { imprint } from './imprint';
import { terms } from './terms';
import { survey } from './survey';

export const de = {
  // Navigation
  nav: {
    home: 'Startseite',
    about: 'Über uns',
    discover: 'Entdecken',
    team: 'Team',
    gallery: 'Galerie',
    pricing: 'Preise',
    blog: 'Blog',
    contact: 'Kontakt',
    survey: 'Ärzteumfrage',
  },

  // Hero Section
  hero: {
    mainTitle: 'TerminTeiler: Zusammen Termine teilen, Fürsorge schaffen!',
    subtitle: 'TerminTeiler befähigt Patienten, ungenutzte Termine weiterzugeben, Wartezeiten zu reduzieren und die Versorgung zu optimieren. Gemeinsam bauen wir eine gerechtere, nachhaltigere Gesundheitszukunft.',
    learnMoreButton: 'Mehr erfahren',
  },

  // Iconbox Section
  iconbox: {
    shareAppointments: {
      title: 'Termine einfach teilen',
      subtitle: 'Ermächtigen Sie andere, indem Sie ungenutzte Slots mit einem einfachen, sicheren Prozess weitergeben.',
    },
    realTimeAvailability: {
      title: 'Echtzeit-Verfügbarkeit',
      subtitle: 'Zugriff auf kurzfristige Termine sofort mit Echtzeit-Benachrichtigungen.',
    },
    supportWhenNeeded: {
      title: 'Unterstützung bei Bedarf',
      subtitle: 'Erhalten Sie schnellere Betreuung, indem Sie geteilte Slots beanspruchen, besonders in Notfällen.',
    },
  },


  // Team Section
  team: {
    feryal: {
      name: 'Feryal Catoglu',
      designation: 'Gründerin & Visionärin',
    },
    faheem: {
      name: 'Faheem Babar',
      designation: 'Mitgründer & Projektmanager',
    },
    haitham: {
      name: 'Haitham El Euch',
      designation: 'Mitgründer & Softwareentwickler',
    },
    jouhaina: {
      name: 'Jouhaina Salsabil El Euch',
      designation: 'Mitgründerin & Softwareentwickler',
    },
  },

  teamSectionData: {
    title: 'Lernen Sie unser TerminTeiler-Team kennen',
    subTitle: 'Entdecken Sie die engagierten Fachleute hinter dem TerminTeiler-Pilotprojekt 2025 in Siegen. <br /> Gemeinsam verändern wir den Zugang zur Gesundheitsversorgung in ganz Deutschland!'
  },

  // Testimonials
  testimonials: {
    ralph: {
      name: 'Dr Shahbaz Chattha',
      designation: 'Geschäftsführer, Smahh',
      quote: 'Ich bin begeistert vom TerminTeiler-Konzept! Das Teilen ungenutzter Termine ist eine brillante Möglichkeit, Wartezeiten zu verkürzen.',
      extraQuote: 'Solidarität im Gesundheitswesen ist die Zukunft!',
    },
    francis: {
      name: 'Adeel Akram',
      designation: 'Biograf',
      quote: 'TerminTeilers Idee ist revolutionär. Es hat mir Wochen des Wartens erspart und ein Gemeinschaftsgefühl gebracht. Große Ausführung!',
      extraQuote: 'Ein Wendepunkt für beschäftigte Fachkräfte.',
    },
    david: {
      name: 'Amna Sabir',
      designation: 'UX-Designer',
      quote: 'Die Benutzerfreundlichkeit der Plattform und die innovative Idee hinter TerminTeiler verdienen Applaus. Es ist eine Lebensader für Patienten!',
      extraQuote: 'Design trifft hier perfekt auf Zweck.',
    },
  },

  // Pricing Section
  pricing: {
    bloodTest: 'Bluttest',
    hemoglobinTest: 'Hämoglobin-Test',
    homocysteineTest: 'Homocystein-Test',
    firstDescription: 'Erste Beschreibung',
    secondDescription: 'Zweite Beschreibung',
    thirdDescription: 'Dritte Beschreibung',
    fourthDescription: 'Vierte Beschreibung',
    fifthDescription: 'Fünfte Beschreibung',
  },

  // FAQ Section
  faq: {
    title: 'Häufig gestellte Fragen',
    questions: {
      whatIsTerminTeiler: {
        title: 'Was ist TerminTeiler?',
        content: 'TerminTeiler ist eine innovative digitale Plattform, die es Patienten in Deutschland ermöglicht, ungenutzte oder stornierte Arzttermine anonym und freiwillig mit anderen Bedürftigen zu teilen. Sie befasst sich mit langen Wartezeiten für Spezialisten, indem bestehende Slots optimiert werden, ohne zusätzliche Belastung für Arztpraxen.',
      },
      howDoesItWork: {
        title: 'Wie funktioniert TerminTeiler?',
        content: 'Bei der Terminbuchung trägt die Arztpraxis den Termin direkt in TerminTeiler ein. Patientinnen und Patienten sehen den Termin in ihrer persönlichen Ansicht und können entscheiden, ob sie ihn behalten oder teilen möchten. Freigegebene Termine werden mithilfe von Radiusfilterung und EchtzeitBenachrichtigungen sichtbar gemacht, sodass andere Personen in der Nähe sie schnell übernehmen können. Der Prozess ist datenschutzkonform und unterstützt eine faire Verteilung freier Arzttermine.',
      },
      whoCanUse: {
        title: 'Wer kann TerminTeiler nutzen?',
        content: 'Die Plattform steht allen Patienten offen, einschließlich Berufstätigen, Eltern, Senioren und Pflegekräften. Sie unterstützt das Teilen für Angehörige wie Kinder oder ältere Verwandte und erstreckt sich auf hochnachgefragte Bereiche wie Kinderärzte, Hebammen, Reha- oder Suchtkliniken.',
      },
      isItSecure: {
        title: 'Ist TerminTeiler sicher und DSGVO-konform?',
        content: 'Ja, TerminTeiler ist vollständig DSGVO-konform. Termine werden anonym geteilt, ohne dass Gesundheitsdaten gespeichert werden. Funktionen umfassen Identitätsverifikation über Registrierung, automatische Löschung nach Übertragung und Praxis-Dashboards zur Überwachung zur Verhinderung von Missbrauch.',
      },
      unclaimedAppointment: {
        title: 'Was passiert, wenn niemand meinen freigegebenen Termin beansprucht?',
        content: 'Wenn er innerhalb des Countdown-Fensters nicht beansprucht wird, kehrt der Slot automatisch als Fallback-Option zum Arztplan zurück. Dies stellt sicher, dass keine Störung der Praxen auftritt, während die Teilungsmöglichkeiten maximiert werden.',
      },
      practicesInsurers: {
        title: 'Können sich Praxen oder Versicherer beteiligen?',
        content: 'Absolut! Praxen erhalten eine eigene Praxisansicht in Form eines Dashboards, das eine einfache Verwaltung und Nachverfolgung ermöglicht. TerminTeiler sucht nicht-kommerzielle Partnerschaften im Rahmen der Lizenzierung. Für Kooperationsanfragen wenden Sie sich bitte an Feryal Catoglu unter info@terminteiler.com',
      },
      whenWillLaunch: {
        title: 'Wann wird TerminTeiler starten?',
        content: 'Wir befinden uns derzeit in der Aufbauphase und planen einen Pilotbetrieb in 3–5 Städten (beginnend in Siegen). Der Testzeitraum beträgt etwa 6–12 Monate. Unterstützen Sie unser Projekt durch die change.org/start-a-petition und bleiben Sie über www.terminteiler.de auf dem Laufenden. Zudem suchen wir interessierte Investoren und Partner, um den deutschlandweiten Start zu ermöglichen.',
      },
      ideaProtection: {
        title: 'Wie ist die TerminTeiler-Idee geschützt?',
        content: 'Die "TerminTeiler" Marke ist beim DPMA eingetragen (April 2025), mit vollständigem Urheberrechtsschutz unter §§ 2, 7 UrhG. Unbefugte Nutzung oder Kommerzialisierung ist verboten—exklusive Lizenzierung stellt Qualitätskontrolle sicher.',
      },
    },
  },


  // Department Section
  department: {
    title: 'TerminTeiler entdecken',
    subtitle: 'Entdecken Sie die wichtigsten Aspekte von TerminTeiler, der innovativen Plattform zum Teilen von Arztterminen in Deutschland. Wartezeiten reduzieren und Gesundheitsversorgung durch Solidarität optimieren.',
    tabs: {
      origin: 'Ursprung',
      overview: 'Übersicht',
      digital: 'Digital',
      community: 'Community',
      legal: 'Rechtliches',
      future: 'Zukunft',
    },
    content: {
      origin: {
        title: 'Wie alles begann: Der Ursprung der Idee',
        subtitle: 'Von einer persönlichen Erfahrung zu einem revolutionären Konzept.',
        text: 'Die Idee für TerminTeiler entstand aus Feryal Catoglus persönlicher Begegnung, bei der sie einen ungenutzten Orthopädie-Termin an jemanden in Not weitergeben wollte. Dieser Moment beleuchtete das weit verbreitete Problem langer Wartezeiten im deutschen Gesundheitssystem und entfachte eine Vision für eine Plattform, auf der Patienten stornierte Termine direkt teilen können. Getrieben von Solidarität und Effizienz zielt TerminTeiler darauf ab, Gesundheitsversorgung zugänglicher zu machen, ohne Arztpraxen zu belasten.',
      },
      overview: {
        title: 'Projektübersicht',
        subtitle: 'TerminTeilers Kernidee und Vorteile verstehen.',
        text: 'TerminTeiler ist eine digitale Plattform, die Patientinnen und Patienten ermöglicht, ungenutzte Arzttermine anonym zu teilen. Sie richtet sich vor allem an Gruppen wie Berufstätige, Eltern und Senioren, ist jedoch grundsätzlich für alle Nutzerinnen und Nutzer gedacht. Die Plattform trägt dazu bei, Wartezeiten deutlich zu verkürzen, Ressourcen im Gesundheitswesen effizienter zu nutzen und Nachhaltigkeit durch papierlose Abläufe zu fördern. TerminTeiler arbeitet in enger Kooperation mit Krankenversicherern und verfolgt einen nicht-kommerziellen Ansatz.',
        readMore: 'Mehr lesen',
      },
      digital: {
        title: 'Digitale Funktionen',
        subtitle: 'Innovative Tools für nahtloses Terminteilen.',
        text: 'TerminTeiler bietet Echtzeit-Features wie Countdown-Fenster für schnelle Ansprüche, Benachrichtigungen für alle Parteien, radiusbasierte Filterung (10-30 km), Glocken-Alerts für passende Slots, Favoriten für bevorzugte Praxen und Nachrichten an Praxen. Es ist vollständig digital und papierlos und fördert Nachhaltigkeit, während es sich auf kurzfristige Termine und Fallback-Optionen für unbeanspruchte Slots konzentriert.',
        readMore: 'Mehr lesen',
      },
      // community: {
      //   title: 'Gemeinschaftsansatz',
      //   subtitle: 'Vertrauen durch Belohnungen und Engagement aufbauen.',
      //   text: 'Der Gemeinschaftsaspekt umfasst ein Punkte-System für verantwortungsvolles Verhalten, wie rechtzeitige Freigaben, das ein Vertrauens-Ranking ähnlich wie bei Ride-Sharing-Apps fördert. Es integriert sich mit betrieblichen Gesundheitsprogrammen (BGM) und Krankenversicherern für Boni wie Workshops oder Veranstaltungen und betont Belohnungen statt Bestrafung, um Solidarität und faire Nutzung zu fördern.',
      //   readMore: 'Mehr lesen',
      // },
      legal: {
        title: 'Rechtliche Aspekte',
        subtitle: 'Sicherheit, Compliance und Schutz gewährleisten.',
        text: 'TerminTeiler priorisiert Kontrolle mit Praxis-Dashboards für Überwachung, automatisierten Löschungen nach Übertragung, bindenden Patienten-Erklärungen und Registrierung für Identitätsverifikation. Das Lizenzierungsmodell ist nicht-kommerziell, mit exklusiven Partnerschaften und einer Premium-Version für private Versicherer. Die Idee ist durch Marke beim DPMA, Urheberrecht geschützt und verbietet unbefugte Nutzung.',
        readMore: 'Mehr lesen',
      },
      future: {
        title: 'Zukunftsvision',
        subtitle: 'Über traditionelle Termine hinaus erweitern.',
        text: 'In die Zukunft blickend plant TerminTeiler einen 6-12 Monate Pilot in 3-5 Städten, misst Erfolg durch übertragene Termine und Zufriedenheit.Durch eine breitere Nutzung ließen sich langfristig deutliche Kosteneinsparungen im Gesundheitswesen erzielen. Zukünftige Erweiterungen decken KI-Vorhersagen, nicht-medizinische Nutzungen wie Reha oder Sport ab und erweiterte Lizenzen für Qualitätskontrolle, um nachhaltiges Wachstum zu gewährleisten.',
        readMore: 'Mehr lesen',
      },
    },
  },

  // About Section
  about: {
    title: 'Gesundheitswesen revolutionieren mit TerminTeiler',
    subtitle: 'TerminTeiler, gegründet von Feryal Catoglu und Faheem Babar, definiert den Zugang zur Gesundheitsversorgung in Deutschland neu, indem Patienten ungenutzte Termine teilen können. Mit der Bewältigung der jährlich 200 Millionen verschwendeten Slots reduzieren wir Wartezeiten und optimieren die Versorgung durch eine gemeinschaftsgetriebene Plattform. Mit KI-gestützter Zuordnung, einem punktebasierten Vertrauenssystem und Partnerschaften mit Versicherern und medizinischen Netzwerken schaffen wir eine nachhaltige, gerechte Gesundheitszukunft.',
    founder: {
      name: 'Faheem Babar Chattha',
      designation: 'Gründerin',
    },
    highlights: [
      'Reduziert 200M+ verschwendete Termine jährlich',
      'Kürzt Wartezeiten um bis zu 30 Tage für Spezialisten',
      'Ermächtigt 18M Patienten mit schnellerem Zugang',
      'Fördert nachhaltige, papierlose Gesundheitsversorgung',
    ],
    contact: '+49 152 38556881',
    sectionTitle: 'Wer wir sind',
    sectionSubtitle: 'TerminTeiler ist eine wegweisende Initiative, die den Gesundheitszugang in Deutschland transformiert. Entdecken Sie eine Plattform, die auf Solidarität und Innovation aufbaut.',
    impactTitle: 'Auswirkungs-Highlights',
    getInTouch: 'Kontakt aufnehmen',
    showMore: 'Unser Team kennenlernen',
    showLess: 'Weniger anzeigen',
  },

  // Contact Section
  contact: {
    title: 'Kontakt mit TerminTeiler aufnehmen',
    subtitle: 'Unterstützen Sie unseren 2025 Pilot-Start in Siegen oder teilen Sie Feedback. Lassen Sie uns gemeinsam den Gesundheitszugang verbessern!',
    form: {
      fullName: 'Vollständiger Name',
      fullNamePlaceholder: 'Geben Sie Ihren vollständigen Namen ein',
      email: 'E-Mail-Adresse',
      emailPlaceholder: 'ihre.email@beispiel.com',
      subject: 'Betreff',
      subjectPlaceholder: 'z.B. Pilot-Unterstützung oder Feedback',
      phone: 'Telefon',
      phonePlaceholder: '+49 152 38556881',
      message: 'Ihre Nachricht',
      messagePlaceholder: 'Teilen Sie Ihre Gedanken oder Fragen zu TerminTeiler...',
      sendButton: 'Nachricht senden',
      sendingButton: 'Wird gesendet...',
      successMessage: 'Vielen Dank! Ihre Nachricht wurde gesendet. Wir melden uns bald bei Ihnen.',
      errorMessage: 'Hoppla! Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.',
    },
  },

  // What People say
  whatPeopleSays: {
    title: 'Was sagen die Menschen?',
    subTitle: 'Entdecken Sie Feedback zu TerminTeiler, der die gemeinsame Nutzung von Arztterminen in Deutschland revolutioniert. <br /> Hören Sie echte Geschichten über Solidarität und Effizienz.'
  },


  // Funfact Section
  funfact: {
    title: 'Ziele nach einem Jahr Start',
    stats: {
      appointmentsShared: 'Geteilte Termine',
      registeredUsers: 'Registrierte Benutzer',
      successfulTransfers: 'Erfolgreiche Übertragungen',
      citiesCovered: 'Abgedeckte Städte',
    },
  },

  // Newsletter Section
  newsletter: {
    title: 'Mit Termin Teiler verbunden bleiben',
    subtitle: 'Abonnieren Sie unseren Newsletter für die neuesten Updates zum Termin Teiler Pilot-Start 2025, Gemeinschaftsveranstaltungen und exklusive Einblicke in Terminteilungs-Innovationen.',
    emailPlaceholder: 'Geben Sie Ihre E-Mail-Adresse ein',
    successMessage: 'Vielen Dank für Ihr Abonnement! Überprüfen Sie Ihren Posteingang zur Bestätigung.',
    errorMessage: 'Hoppla! Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.',
    whatsappText: 'Chatten Sie mit uns auf WhatsApp',
  },

  // Footer Section
  footer: {
    subTitle: 'Ermächtigen Sie Gesundheitsgerechtigkeit mit TerminTeiler! Gestartet 2025, unsere Mission ist es, Patienten in Deutschland zu verbinden, beginnend mit dem Siegen-Pilot, um Termine zu teilen und den Versorgungszugang bis Oktober 2025 zu transformieren.',
    usefulLinks: 'Nützliche Links',
    legalLinks: 'Rechtliches',
    contacts: 'Kontakte',
    address: 'Adresse:',
    addressLine: 'Sandstraße 26, 57072 Siegen, Deutschland',
    email: 'E-Mail:',
    phone: 'Telefon:',
    copyright: 'Copyright {year}. Von TerminTeiler',
    links: {
      faqs: 'FAQs',
      blog: 'Blog',
      timetable: 'Wöchentlicher Stundenplan',
      terms: 'Allgemeine Geschäftsbedingungen',
      privacyPolicy: 'Datenschutzerklärung',
      cookiePolicy: 'Cookie-Richtlinie',
      cookieSettings: 'Cookie-Einstellungen',
      imprint: 'Impressum',
      termsConditions: 'AGB',
    },
  },

  // Brands Section
  brands: {
    title: 'Unsere Sponsoren',
    subtitle: 'Unterstützende Organisationen, die unsere Vision für besseren Gesundheitszugang teilen',
  },

  // Language Switcher
  language: {
    english: 'English',
    german: 'Deutsch',
    selectLanguage: 'Sprache auswählen',
  },

  // SEO
  seo: {
    siteName: 'TerminTeiler',
    defaultTitle: 'TerminTeiler - Arzttermine teilen | Wartezeiten reduzieren',
    defaultDescription: 'TerminTeiler befähigt Patienten, ungenutzte Termine weiterzugeben, Wartezeiten zu reduzieren und die Versorgung zu optimieren. Gemeinsam bauen wir eine gerechtere, nachhaltigere Gesundheitszukunft.',
    home: {
      title: 'TerminTeiler - Arzttermine teilen | Wartezeiten reduzieren',
      description: 'TerminTeiler befähigt Patienten, ungenutzte Termine weiterzugeben, Wartezeiten zu reduzieren und die Versorgung zu optimieren. Gemeinsam bauen wir eine gerechtere, nachhaltigere Gesundheitszukunft.',
      keywords: 'Arzttermin, Termin teilen, Gesundheitsversorgung, Wartezeiten reduzieren, Deutschland, Arzttermin weitergeben, Terminvermittlung',
    },
  },

  // Privacy Policy
  privacy,

  // Cookie Policy
  cookies,

  // Imprint
  imprint,

  // Terms and Conditions
  terms,

  // Survey
  survey,
};
